module.exports = __webpack_public_path__ + "static/media/showevent_content_TAOS_2018_md.13b6d2be.png";